import React, { useEffect, useState } from 'react';

function ToggleSwitch({ state, message, updateIsActive }) {
  const [isChecked, setIsChecked] = useState(state);

  const handleToggle = () => {
    const newIsActive = !isChecked;
    setIsChecked(newIsActive);
    updateIsActive(newIsActive);
  };
  useEffect(()=>{
    setIsChecked(state);
    updateIsActive(state);
  } , [state])
  const callbackState = isChecked ? 'on' : 'off';

  return (
    <div className='d-flex '> 
    <label className="form-check-label mb-0  h6 m-3" htmlFor={message}>
    {message}
  </label>
    <span className="form-check form-switch m-3">
       
      <input
        className="form-check-input"
        type="checkbox"
        id={message}
        checked={isChecked}m 
        onChange={handleToggle}
        data-gtm-form-interact-field-id="0"
      /> 

  
      
    </span>
    </div>
  );
}

export default ToggleSwitch;